import React from "react";
import Dashboard from "./Dashboard";
import About from "./About";

const Dash_About = () => {
  return (
    <>
      <Dashboard />
      <About />
    </>
  );
};

export default Dash_About;
